module.exports = __webpack_public_path__ + "85bd521b3a88f5a005cfa5fcf9064bf6.jpg";